export const MOBILE_SCREEN_SIZE = 600;
export const TABLET_SCREEN_SIZE = 1050;
export const DIALOG_SCREEN_SIZE = 625;
export const SMALL_TABLET_SCREEN_SIZE = 768;
export const DESKTOP_SCREEN_SIZE = 1680;
export const DESKTOP_HORIZONTAL_PADDING = 140;

export const MOBILE_HORIZONTAL_PADDING = 20;
export const TABLET_HORIZONTAL_PADDING = 40;

export const WIDGET_SPACE = 50;
export const WIDGET_SPACE_HALF = WIDGET_SPACE / 2;

export const WIDGET_MEDIA_BORDER_RADIUS = 5; // image / videp

export const DEFAULT_LINK_ID = '#';

export enum BRANDCLUB_RETAILERS {
  Amazon = 1,
  Walmart = 2,
  BestBuy = 3,
  Target = 4,
  Costco = 9,
  Chewy = 18,
  Kroger = 48,
  Sephora = 50,
  Safeway = 92,
  Qfc = 93,
  Albertsons = 94,
  FredMeyer = 127,
  Ralphs = 128,
  KrogerFamily = 129,
  AlbertsonsFamily = 170,
  HomeDepot = 6,
}

export const WIDGET_PAIR_PRODUCT_PADDING = 50;
export const PLACEHOLDER_GREEN_IMAGE = {
  '1X1': 'https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_1x1.png',
} as const;

export const BRANDCLUB_BRAND_ID = 50000;
export const UNIVERSAL_STORE_SITE = 'https://brandclub.com';
